import { autoinject, bindable } from 'aurelia-framework';
import { AsyncErrorHandler } from 'lib/ui';
import { PenDto } from 'models/pen/Pen';
import { PenDimensionDto } from 'models/pen/PenDimension';
import { PenBridleConfigService } from 'services/pen/pen-bridle-config-service';
import { PenDesignTypeService } from 'services/pen/pen-design-type-service';
import { PenDimensionService } from 'services/pen/pen-dimension-service';
import { PenService } from 'services/pen/pen-service';
import { ToastService } from 'services/toast-service';
import { UserManualService } from 'services/user-manual-service';

@autoinject
export class PenSpecificationContainer {
  @bindable
  protected penId: number;

  protected isLoading = true;
  protected pen: PenDto;
  protected penDimension: PenDimensionDto;

  protected railPipeDiameterOptions = [
    { Id: 140, Name: 140, Value: '140' },
    { Id: 125, Name: 125, Value: '125' },
    { Id: 110, Name: 110, Value: '110' },
  ]

  protected sdrWalkWayDiameterOptions = [
    { Id: 70, Name: 70, Value: '70' },
    { Id: 63, Name: 63, Value: '63' },
    { Id: 40, Name: 40, Value: '40' },
    { Id: 25, Name: 25, Value: '25' },
  ]

  constructor(
    private penService: PenService,
    private penDimensionService: PenDimensionService,
    private toastService: ToastService,
    private userManualService: UserManualService,
    private penDesignTypeService: PenDesignTypeService,
    private penBridleConfigService: PenBridleConfigService
  ) {}

  protected async attached() {
    await this.getPen(this.penId);
    await this.getPenDimension(this.pen.PenDimensionId);
    this.isLoading = false;
  }

  @AsyncErrorHandler
  async getPenDimension(id: number) {
    const { data } = await this.penDimensionService.getPenDimension(id);
    this.penDimension = data;
  }

  @AsyncErrorHandler
  async getPen(id: number) {
    const { data } = await this.penService.getPen(id);
    this.pen = data;
  }

  @AsyncErrorHandler
  async save() {
    await this.penDimensionService.updatePenDimension(this.penDimension.Id, this.penDimension);
    this.toastService.showSuccess('pens.penDimension.updated');
  }

  @AsyncErrorHandler
  async getPenDesignTypes() {
    return await this.penDesignTypeService.getAll();
  }

  @AsyncErrorHandler
  async getPenBridleConfigs() {
    return await this.penBridleConfigService.getAll();
  }

  @AsyncErrorHandler
  async getUserManuals() {
    const userManuals = await this.userManualService.getAll();
    userManuals.forEach((userManual) => {
      userManual.Name = userManual.Name + ' Rev. ' + userManual.Revision;
      userManual.NameEn = userManual.NameEn + ' Rev. ' + userManual.Revision;
      userManual.NameEs = userManual.NameEs + ' Rev. ' + userManual.Revision;
    });

    return userManuals;
  }
}
